import React, {Component,} from 'react'
// import {View} from 'react-native'


import PropTypes from 'prop-types'

class CCErrorBoundary extends Component {

    static propTypes = {
        fallbackUI: PropTypes.element
    }

    static defaultProps = {
        fallbackUI: <div></div>
    }


    constructor(props) {
        super(props)
        this.state = {
            hasError: false
        }
    }

    componentDidCatch(error) {
        this.setState({hasError: true});
        //Firebase.crashlytics().recordError(-1000, error.message );
    }


    render() {
        //console.log(topTitle, bottomTitle, showVersion)
        if (this.state.hasError == true) {
            return this.props.fallbackUI;
        }
        else {
            return this.props.children;
        }

    }
}

export default CCErrorBoundary



// WEBPACK FOOTER //
// ./src/app/components/CCErrorBoundary/CCErrorBoundary.js